import { auditLogService } from "../services/auditLogService";
import { useAsyncData } from "./useAsyncData";

export function useAuditLogs(filters?: {
  search?: string;
  tenantId?: string;
  action?: string;
  entityType?: string;
}) {
  const key = JSON.stringify(filters ?? {});
  return useAsyncData(() => auditLogService.listAuditLogs(filters), [key]);
}
